"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportarModal = void 0;
var react_1 = __importStar(require("react"));
var index_css_1 = __importDefault(require("./index.css"));
var texts_1 = require("../../ui/texts");
var text_field_1 = require("../../ui/text-field");
var buttons_1 = require("../../ui/buttons");
var api_1 = require("../../lib/api");
var exit_svg_1 = __importDefault(require("../../static/images/exit.svg"));
function ReportarModal(petData) {
    var _a = (0, react_1.useState)(false), showErrorMessage = _a[0], setShowErrorMessage = _a[1];
    function handleSubmit(e) {
        e.preventDefault();
        setShowErrorMessage(false);
        if (!e.target.phone.value || !e.target.info.value || !e.target.name.value) {
            setShowErrorMessage(true);
            return;
        }
        var newReportData = {
            name: e.target.name.value,
            phoneNumber: e.target.phone.value,
            description: e.target.info.value,
            petId: petData.id,
            contact: petData.contact,
        };
        (0, api_1.postNewReport)(newReportData).then(function (res) {
            petData.setShow(false);
        });
    }
    return (react_1.default.createElement("form", { onSubmit: handleSubmit, className: index_css_1.default["modal-container"] },
        react_1.default.createElement("img", { onClick: function () {
                petData.setShow(false);
            }, src: exit_svg_1.default, alt: "exit", className: index_css_1.default.exit }),
        react_1.default.createElement("div", { className: index_css_1.default["title-container"] },
            react_1.default.createElement(texts_1.CustomSubtitle, null,
                "Reportar info de ",
                petData.name)),
        react_1.default.createElement(text_field_1.TextField, { autoFocus: true, label: "TU NOMBRE", name: "name", type: "text", className: index_css_1.default.name }),
        react_1.default.createElement(text_field_1.TextField, { className: index_css_1.default.phone, label: "TU TELEFONO", name: "phone", type: "text" }),
        react_1.default.createElement("div", { className: index_css_1.default.info },
            react_1.default.createElement(text_field_1.TextArea, { label: "DONDE LO VISTE?", name: "info", type: "text" })),
        react_1.default.createElement("div", { className: index_css_1.default["button-container"] },
            showErrorMessage && (react_1.default.createElement("p", { className: index_css_1.default.error }, "Los campos no pueden quedar vacios")),
            react_1.default.createElement(buttons_1.MainButton, { color: "pink" }, "Enviar"))));
}
exports.ReportarModal = ReportarModal;
